import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useWaMsg, waUrl } from "@/lib/waTemplates";
import { Cake, MessageCircle } from "lucide-react";

const MONTHS = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

export function BirthdaysHubCard() {
  const { user } = useAuth();
  const waMsg = useWaMsg();
  const [rows, setRows] = useState(null);
  const link = user?.shop?.birthday_link;
  const month = new Date().getMonth() + 1;
  useEffect(() => { api.get("/birthdays", { params: { month } }).then(({ data }) => setRows(data.items || [])).catch(() => setRows([])); }, [user?.shop_id, month]);
  if (rows == null) { return null; }
  if (!rows.length) { return null; }
  const msgFor = (c) => {
    const first = (c.name || "").split(" ")[0];
    const t = waMsg("birthday", { nome: first, cliente: first });
    return link ? `${t}\n${link}` : t;
  };
  return (
    <section data-testid="hub-birthdays" className="rounded-2xl border border-amber-brand/40 bg-amber-brand/5 p-4 space-y-3">
      <div className="flex items-center gap-2">
        <Cake className="h-5 w-5 text-amber-brand" />
        <h2 className="font-display text-base font-bold uppercase text-zinc-100">Aniversariantes de {MONTHS[month - 1]}</h2>
        <span data-testid="hub-birthdays-count" className="ml-auto text-xs text-zinc-400">{rows.length} aniversariante(s)</span>
      </div>
      <ul className="divide-y divide-zinc-800">
        {rows.slice(0, 6).map((c) => {
          const href = waUrl(c.phone, msgFor(c));
          return (
            <li key={c.id} data-testid={`hub-birthday-${c.id}`} className="flex items-center gap-3 py-2">
              <span className="w-9 text-center font-display text-lg font-black text-amber-brand tabular-nums">{c.birth_date.slice(8, 10)}</span>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-bold text-zinc-100 truncate">{c.name}{c.kind === "funcionario" && <span data-testid={`hub-birthday-employee-${c.id}`} className="ml-2 rounded-full border border-sky-600 bg-sky-900/40 px-2 text-[10px] font-bold uppercase text-sky-200">Funcionário</span>}</div>
                <div className="text-xs text-zinc-500 truncate">{c.phone || "sem telefone"}</div>
              </div>
              {href && <a data-testid={`hub-birthday-wa-${c.id}`} href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 h-9 px-3 rounded-md bg-green-600 hover:bg-green-500 text-white text-xs font-bold"><MessageCircle className="h-4 w-4" /> Parabéns</a>}
            </li>
          );
        })}
      </ul>
      {rows.length > 6 && <p className="text-xs text-zinc-500">+{rows.length - 6} outros em Clientes.</p>}
    </section>
  );
}
